import "../../i18n/i18n";
import { VehiclesTable } from "./tables/vehiclesTable";
import { useVehicles } from "./useVehicles";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Spacer, triggerToast } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import {
  telemetrySlice,
  selectConnectDevicesToProviderStatus,
} from "./telemetrySlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import styled from "styled-components";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";

export const AddDevicesToProviderTab = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const params = useParams();
  const vehiclesListWithId = useVehicles();
  const connectDevicesToProviderStatus = useAppSelector(
    selectConnectDevicesToProviderStatus,
  );

  const filteredVehiclesListWithId = useMemo(() => {
    return vehiclesListWithId.filter((v) => !v.dataProvider && !v.deviceId);
  }, [vehiclesListWithId]);

  useEffect(() => {
    if (connectDevicesToProviderStatus === "success") {
      triggerToast(t("telemetry.addDevicesToProvider.success") || "", "valid");
      dispatch(telemetrySlice.actions.resetConnectDevicesToProviderStatus());
    } else if (connectDevicesToProviderStatus === "failed") {
      triggerToast(t("telemetry.addDevicesToProvider.failure") || "", "error");
      dispatch(telemetrySlice.actions.resetConnectDevicesToProviderStatus());
    }
  }, [connectDevicesToProviderStatus, t, dispatch, params.id]);

  if (params.tab !== "addDevicesToProvider") {
    return;
  }

  return (
    <StyledContainer>
      <Spacer y={1} />
      <StyledDescription>
        {t("telemetry.addDevicesToProvider.description")}
      </StyledDescription>
      <Spacer y={1} />
      <StyledDescription>
        {t("telemetry.addDevicesToProvider.description2")}
      </StyledDescription>
      <Spacer y={1} />
      <StyledTableContainer>
        <VehiclesTable
          vehiclesListWithId={filteredVehiclesListWithId}
          pageName="vehiclesOfACompany"
          pageTitle="Add-devices-to-provider"
          dataProvider="FLESPI"
          canEditDeviceId
        />
      </StyledTableContainer>
    </StyledContainer>
  );
};

const StyledDescription = styled.div`
  ${typographies["Header/H3"]}
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: hidden;
`;

const StyledTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
`;